import { useMsal } from "@azure/msal-react";
import { loginRequest, msalConfig } from "../authConfig";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function Login() {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const handleRedirect = async () => {
      if (accounts.length > 0) {
        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });

          localStorage.setItem("accessToken", response.accessToken);
          localStorage.setItem("userEmail", response.account.username);

          navigate("/new-expense");
        } catch (error) {
          console.error("Silent token acquisition failed, falling back to interactive", error);
          try {
            const response = await instance.acquireTokenRedirect({
              ...loginRequest,
              redirectUri: msalConfig.auth.redirectUri,
            });
            localStorage.setItem("accessToken", response.accessToken);
            localStorage.setItem("userEmail", response.account.username);
            navigate("/new-expense");
          } catch (err) {
            console.error("Token acquisition via redirect failed:", err);
          }
        }
      }
    };

    handleRedirect();
  }, [accounts, instance, navigate]);

  const handleLogin = () => {
    instance.loginRedirect({
      ...loginRequest,
      redirectUri: msalConfig.auth.redirectUri,
    });
  };

  return (
    <div className="min-h-screen flex flex-col justify-between" style={{ background: 'var(--bg)' }}>
    {/* Main Content - Centered Box */}
    <div className="flex w-full max-w-6xl mx-auto shadow-lg rounded-lg overflow-hidden my-auto border" style={{ background: 'var(--panel)', borderColor: 'var(--border)' }}>
      {/* Left Side */}
      <div className="w-1/2 p-12" style={{ background: 'var(--panel)' }}>
        <img src="/acorn.png" alt="ACORN Logo" />

        <h2 className="text-2xl font-bold mb-4 text-center">Expense Management & Approval</h2>
      </div>

      {/* Right Side - Login */}
      <div className="w-1/2 p-12 bg-gray-50 border-l">
        <div className="text-center mb-16 mt-16">
          <h3 className="text-4xl font-bold">Welcome</h3>
          <p className="text-gray-600">Sign in to access expense management dashboard</p>
        </div>

        <button
          className="w-full bg-red-700 hover:bg-red-800 text-white py-3 rounded-md mb-4 flex items-center justify-center gap-2"
          onClick={handleLogin}
        >
          <img src="/microsoft-logo.png" alt="Microsoft" className="h-5" />
          Continue with Microsoft
        </button>

          <div className="text-center text-sm text-green-600 mt-4">
            ✔ Your connection is secured with enterprise-grade encryption
          </div>

          <div className="mt-6 text-center text-sm text-gray-500">
            Don’t have an account?{" "}
            <a
              href="mailto:tanvi.laddha@acornuniversalconsultancy.com"
              className="text-red-600 underline hover:text-red-700"
            >
              Contact your administrator
            </a>
          </div>
        </div>
      </div>

    {/* Footer */}
    <footer className="text-center text-sm text-gray-500 py-4">
      © 2025 Acorn Universal Consultancy LLP. All rights reserved.
    </footer>
  </div>
);
  
}

export default Login;



// import { useMsal } from "@azure/msal-react";
// import { loginRequest } from "../authConfig";
// import { useNavigate } from "react-router-dom";
// import { useEffect } from "react";

// function Login() {
//   const { instance, accounts } = useMsal();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleRedirect = async () => {
//       if (accounts.length > 0) {
//         try {
//           const response = await instance.acquireTokenSilent({
//             ...loginRequest,
//             account: accounts[0],
//           });

//           // ✅ Save token and user email
//           localStorage.setItem("accessToken", response.accessToken);
//           localStorage.setItem("userEmail", response.account.username);

//           navigate("/new-expense");
//         } catch (error) {
//           console.error("Silent token acquisition failed, falling back to interactive", error);

//           try {
//             const response = await instance.acquireTokenRedirect(loginRequest);
//             localStorage.setItem("accessToken", response.accessToken);
//             localStorage.setItem("userEmail", response.account.username);

//             navigate("/new-expense");
//           } catch (err) {
//             console.error("Token acquisition via redirect failed:", err);
//           }
//         }
//       }
//     };

//     handleRedirect();
//   }, [accounts, instance, navigate]);

//   const handleLogin = () => {
//     instance.loginRedirect(loginRequest); // you already had this
//   };

//   return (
//     <div className="container mt-5 text-center">
//       <h2>Welcome to Expense Approval App</h2>
//       <p>Sign in with your Outlook account</p>
//       <button className="btn btn-primary" onClick={handleLogin}>
//         Login with Microsoft
//       </button>
//     </div>
//   );
// }

// export default Login;

